var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParagraphBody',{class:[_vm.$style.legalNotice],attrs:{"bodySize":_vm.$options.bodySizes.tiny,"data-test-id":"legal-notice","hasMargin":""}},[_vm._v(" "+_vm._s(_vm.legalNotice)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }